import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail === "verification_required") return "Verify your email and mobile number to unlock PDF downloads and saved projects.";
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadPdfFile(path, filename) {
  // Verifies auth + generation succeed before triggering the browser download
  const res = await api.get(path, { responseType: "blob" });
  let inIframe = false;
  try {
    inIframe = window.self !== window.top;
  } catch {
    inIframe = true;
  }
  const a = document.createElement("a");
  if (inIframe) {
    // Sandboxed iframes (platform preview) block blob-URL navigation — use the direct
    // same-origin API URL instead; Content-Disposition: attachment triggers a native download
    a.href = `${process.env.REACT_APP_BACKEND_URL}/api${path}`;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    return;
  }
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

export default api;
